import React from "react";

import { useIntl } from "react-intl";

import CountryCode from "@mapmycustomers/shared/enum/CountryCode";
import getCountryFlag from "@mapmycustomers/shared/util/countries/getCountryFlag";

import formatCountryName from "@app/util/countries/formatCountryName";

import styles from "./CountryWithFlag.module.scss";

interface Props {
  countryCode: CountryCode;
}

const CountryWithFlag = ({ countryCode }: Props) => {
  const intl = useIntl();
  return (
    <div className={styles.container}>
      <div className={styles.flag}>{getCountryFlag(countryCode)}</div>
      <div>{formatCountryName(intl, countryCode)}</div>
    </div>
  );
};

export default CountryWithFlag;
